/* Sitwell cart controller. Vanilla JS. Talks to the standard Shopify cart AJAX API, then swaps the cart markup. */
(function () {
  if (window.__sitwellCart) return;
  window.__sitwellCart = true;

  var base = function (name, fallback) {
    return ((window.routes && window.routes[name]) || fallback) + '.js';
  };
  var changeUrl = function () { return base('cart_change_url', '/cart/change'); };
  var addUrl = function () { return base('cart_add_url', '/cart/add'); };
  var root = function () { return document.querySelector('[data-fc-root]'); };

  function showError(msg) {
    var box = document.querySelector('[data-fc-error]');
    if (!box) return;
    box.textContent = msg || (window.cartStrings && window.cartStrings.error) || 'Something went wrong. Please try again.';
    box.hidden = false;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status === 422 || data.errors) {
          throw new Error(data.description || data.message || (typeof data.errors === 'string' ? data.errors : ''));
        }
        return data;
      });
    });
  }

  function refresh() {
    var focusKey = document.activeElement && document.activeElement.getAttribute && document.activeElement.getAttribute('data-key');
    var focusQty = document.activeElement && document.activeElement.getAttribute && document.activeElement.getAttribute('aria-label');
    return fetch(location.pathname + location.search, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-fc-root]');
        var cur = root();
        if (!next || !cur) { location.reload(); return; }
        cur.innerHTML = next.innerHTML;
        var counts = doc.querySelectorAll('.fx-cartcount');
        var live = document.querySelectorAll('.fx-cartcount');
        if (counts[0]) { for (var i = 0; i < live.length; i++) live[i].textContent = counts[0].textContent; }
        if (focusKey) {
          var el = cur.querySelector('[data-key="' + focusKey + '"][aria-label="' + (focusQty || '') + '"]') || cur.querySelector('[data-key="' + focusKey + '"]');
          if (el && !el.disabled) el.focus();
        }
      });
  }

  function busy(el, on) {
    var line = el.closest('[data-fc-line],[data-fc-nudge]');
    if (line) line.classList.toggle('is-busy', on);
    el.disabled = on;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-fc-act]') : null;
    if (!btn || !root() || !root().contains(btn)) return;
    e.preventDefault();
    if (btn.disabled) return;
    var act = btn.getAttribute('data-fc-act');
    var key = btn.getAttribute('data-key');
    busy(btn, true);
    var job;
    if (act === 'qty') {
      var q = parseInt(btn.getAttribute('data-qty'), 10);
      job = post(changeUrl(), { id: key, quantity: q < 0 ? 0 : q });
    } else if (act === 'switch') {
      var variant = parseInt(btn.getAttribute('data-variant'), 10);
      job = post(addUrl(), { id: variant, quantity: 1 }).then(function () {
        return post(changeUrl(), { id: key, quantity: 0 });
      });
    } else {
      busy(btn, false);
      return;
    }
    job.then(refresh).catch(function (err) {
      busy(btn, false);
      showError(err && err.message);
    });
  });
})();
